// #Global Imports
import React from "react";
// #end Global Imports

const Footer = () => {
  return (
    <div className="relative items-center justify-between hidden w-full md:flex">
      <div className="absolute bottom-0 left-0 right-0">
        <img src="/images/svg/footer.svg" alt="footer-image" width="100%" height="250px" />
      </div>
    </div>
  );
};

export default Footer;
